import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent implements OnChanges {
  public readonly sideArrows = input(false);
  public readonly isGalleryOpen = input(true);
  public readonly currentPage = input(1);
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() public pageCount = 1;
  public readonly presentationV3 = input(false);
  public readonly isMobile = input(false);
  public readonly nextPageSelected = output<boolean>();
  public readonly prevPageSelected = output<boolean>();

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.pageCount) {
      this.removeDotsClass();
    }
  }

  public getPagesToShow(): number[] {
    const pagesToShow: number[] = [];
    for (let i = 1; i <= this.pageCount; i++) {
      pagesToShow.push(i);
    }
    if (this.pageCount > 10) {
      this.addDotsClass();
    }
    return pagesToShow;
  }

  protected trackPagesByIndex(index: number, page: number): number {
    return page;
  }

  private addDotsClass() {
    const dots = document.querySelectorAll('.dot');
    const activeDot = dots[this.currentPage() - 1];
    const dotSize1 = 'dot-size-1';
    const dotSize2 = 'dot-size-2';
    const dotSize3 = 'dot-size-3';

    this.removeDotsClass();

    if (activeDot) {
      activeDot.previousElementSibling?.previousElementSibling?.previousElementSibling?.classList.add(dotSize1);
      activeDot.previousElementSibling?.previousElementSibling?.classList.add(dotSize2);
      activeDot.previousElementSibling?.classList.add(dotSize3);
      activeDot.nextElementSibling?.classList.add(dotSize3);
      activeDot.nextElementSibling?.nextElementSibling?.classList.add(dotSize2);
      activeDot.nextElementSibling?.nextElementSibling?.nextElementSibling?.classList.add(dotSize1);
    }
  }

  private removeDotsClass() {
    const dots = document.querySelectorAll('.dot');
    dots.forEach((dot) => dot.classList.remove('dot-size-1', 'dot-size-2', 'dot-size-3'));
  }

  public onNextPageClick() {
    this.nextPageSelected.emit(true);
  }

  public onPrevPageClick() {
    this.prevPageSelected.emit(true);
  }
}
